import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import api from '../../services/api';

// Kademesi / iş ailesi atanmamış ünvan ve çalışan sayısı (spec 2026-10-27 §6.2) — kademesiz kalan
// ünvanlar sessizce kaybolmasın. Sayfa içi tek satırlık uyarı; iç kaydırma YOK.
const Box = styled.div`
  background: #FFF8E6;
  border-left: 3px solid #FFC107;
  border-radius: 4px;
  padding: 10px 12px;
  margin-bottom: 12px;
  font-size: ${({ theme }) => theme.metrics.font.size.xs};
  color: ${({ theme }) => theme.colors.text.primary};
  display: flex;
  flex-direction: column;
  gap: 4px;

  a { margin-left: 8px; font-weight: 600; }
`;

export default function ArchitectureCoverageNotice({ refreshKey }) {
  const { t } = useTranslation();
  const [coverage, setCoverage] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api.get('/v1/job-grades/coverage')
      .then((res) => { if (!cancelled && res.data?.status) setCoverage(res.data.data); })
      .catch(() => { /* interceptor */ });
    return () => { cancelled = true; };
  }, [refreshKey]);

  if (!coverage) return null;
  const lines = [];
  if (coverage.titlesWithoutGrade > 0) {
    lines.push(
      <div key="grade" data-testid="coverage-grade">
        {t('jobGrade.coverage.withoutGrade', { titles: coverage.titlesWithoutGrade, employees: coverage.employeesWithoutGrade })}
        <Link to="/titles?gradeMissing=1">{t('jobGrade.coverage.show')}</Link>
      </div>,
    );
  }
  if (coverage.titlesWithoutFamily > 0) {
    lines.push(
      <div key="family" data-testid="coverage-family">
        {t('jobGrade.coverage.withoutFamily', { titles: coverage.titlesWithoutFamily, employees: coverage.employeesWithoutFamily })}
        <Link to="/titles?jobFamilyMissing=1">{t('jobGrade.coverage.show')}</Link>
      </div>,
    );
  }
  return lines.length ? <Box data-testid="architecture-coverage">{lines}</Box> : null;
}
